/**
 * SSO Sign-Out Callback Page
 * Handles the redirect after signing out from the identity provider
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './SSOCallbackPage.module.css';

const SignOutCallbackPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleSignOutCallback = async () => {
      console.log('Sign-out callback received');

      // Clear any local storage or session storage if needed
      sessionStorage.removeItem('ssoReturnUrl');
      sessionStorage.removeItem('ssoState');
      localStorage.removeItem('userInfo');

      // Redirect and navigate immediately to the login page as requested
      navigate('/login');
    };

    handleSignOutCallback();
  }, [navigate]);

  return null;
};

export default SignOutCallbackPage;
